<template>
  <b-modal
    modal-class="component-modal-product"
    id="createOrUpdatePurchaseRequestModal"
    ref="createOrUpdatePurchaseReuqestModel"
    size="xl"
    title="รายการใบขอซื้อ"
    no-close-on-backdrop
    @close="close"
    @hidden="resetForm"
  >
    <div class="pr-info-row">
      <span class="pr-info-label">รหัสใบวางแผนความต้องการวัสดุ:</span>
      <span class="pr-info-value">{{ mrpNo }}</span>
    </div>

    <b-table
      id="createPurchaseRequestTable"
      :items="items"
      :fields="fields"
      responsive
      hover
      small
      sort-icon-left
      head-variant="light"
    >
      <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>

      <template v-slot:cell(product)="row">
        <MultipleSelectField
          :value="row.item.product"
          :options="getProductOptionsForRow(row.index)"
          :is-required="true"
          :is-error="row.item.productTouched && !row.item.product"
          placeholder="รหัสสินค้า - ชื่อสินค้า"
          track-by="productId"
          :custom-label="productLabel"
          :show-error-icon="false"
          @input="onProductChange(row.index, $event)"
        />
      </template>

      <template v-slot:cell(qty)="row">
        <InputNumberField
          :adjust-stock="row.item.qty"
          :min="0"
          :show-buttons="true"
          :is-required="true"
          :allow-decimal="false"
          :invalid="row.item.qtyTouched && !row.item.qty"
          :disabled="!row.item.product"
          :on-change="val => onQtyChange(row.index, val)"
          :show-error-icon="false"
        />
      </template>

      <template v-slot:cell(unit)="row">
        <MultipleSelectField
          :isRequired="true"
          v-model="row.item.unit"
          :options="getUnitOptions(row.item)"
          :isError="
            !!row.item.product && !row.item.unit && row.item.productTouched
          "
          placeholder="เลือกหน่วยสินค้า"
          trackBy="id"
          :customLabel="unitLabel"
          selectLabel=""
          selectedLabel=""
          deselectLabel=""
          :disabled="!row.item.product"
          :allowEmpty="false"
          :show-error-icon="false"
        />
      </template>

      <template v-slot:cell(actions)="row">
        <button
          class="delete-btn"
          :disabled="items.length <= 1"
          @click="removeItem(row.index)"
        >
          <i class="fas fa-trash-alt"></i>
        </button>
      </template>

      <template v-slot:bottom-row>
        <td
          colspan="5"
          class="bottom-row-cell"
        >
          <b-button
            type="button"
            variant="outline-primary"
            @click="addItem"
            class="bottom-add-row"
          >
            <i class="fas fa-plus"></i> เพิ่มรายการสินค้า
          </b-button>
        </td>
      </template>
    </b-table>

    <template v-slot:modal-footer>
      <span
        v-if="isCreate()"
        class="footer-warning-text"
      >
        การสร้างรายการจะเป็นการส่งข้อมูลให้ผู้จัดการอนุมัติ
        กรุณาตรวจสอบข้อมูลให้ถูกต้อง
      </span>
      <b-button
        v-if="isCreate()"
        variant="primary"
        @click="create"
        >สร้างรายการ</b-button
      >
      <b-button
        v-else
        variant="primary"
        @click="update"
        >แก้ไขรายการ</b-button
      >
    </template>

    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import MultipleSelectField from "@/components/table/stock/fields/MultipleSelectField.vue";
import InputNumberField from "@/components/table/stock/fields/InputNumberField.vue";
import { mapActions } from "vuex";

const createEmptyItem = () => ({
  product: null,
  qty: 0,
  unit: null,
  productTouched: false,
  qtyTouched: false,
});

export default {
  name: "CreateOrUpdatePurchaseReuqestModel",
  components: {
    Loading,
    MultipleSelectField,
    InputNumberField,
  },
  data() {
    return {
      isLoading: false,
      submitted: false,
      type: "CREATE",
      prId: null,
      mrpNo: null,
      mrpId: null,
      productList: [],
      items: [createEmptyItem()],
      fields: [
        { key: "index", label: "", thStyle: { width: "4%" } },
        {
          key: "product",
          label: "รหัสสินค้า - ชื่อสินค้า",
          thStyle: { width: "46%" },
        },
        { key: "qty", label: "จำนวน", thStyle: { width: "15%" } },
        { key: "unit", label: "หน่วยสินค้า", thStyle: { width: "15%" } },
        {
          key: "actions",
          label: "",
          thStyle: { width: "6%", minWidth: "60px" },
          class: "text-center",
        },
      ],
    };
  },
  computed: {
    selectedProductIds() {
      return this.items.map(i => i.product?.productId).filter(id => id != null);
    },
  },
  methods: {
    ...mapActions({
      createPurchaseReuqest: "modulePurchaseRequest/createPurchaseReuqest",
      updatePurchaseRequest: "modulePurchaseRequest/updatePurchaseRequest",
      fetchMrpList: "moduleMrp/fetchMrpList",
      fetchPurchaseRequests: "modulePurchaseRequest/fetchPurchaseRequests",
    }),
    show({ prId, mrpNo, mrpId, products, productList, type }) {
      this.prId = prId || null;
      this.mrpNo = mrpNo;
      this.mrpId = mrpId;
      this.type = type;
      this.productList = productList || [];
      this.items = products?.length
        ? products.map(p => {
            const matched =
              this.productList.find(
                pl =>
                  pl.productId === p.productId ||
                  pl.productId === p.id ||
                  pl.productCode === p.no ||
                  pl.productCode === p.productCode
              ) || null;
            const defaultUnit = matched?.productUnit
              ? {
                  id: matched.productUnit.id,
                  name: matched.productUnit.description,
                }
              : p.uom
              ? { id: p.uom.id, name: p.uom.description }
              : p.uomId
              ? { id: p.uomId, name: p.uomName || "" }
              : null;
            return {
              product: matched,
              qty: p.quantity ?? 1,
              unit: defaultUnit,
              productTouched: false,
              qtyTouched: false,
            };
          })
        : [createEmptyItem()];
      this.$bvModal.show("createOrUpdatePurchaseRequestModal");
    },
    isCreate() {
      console.info(this.type);
      return this.type === "CREATE";
    },
    isUpdate() {
      return this.type === "UPDATE";
    },
    close() {
      this.$bvModal.hide("createOrUpdatePurchaseRequestModal");
    },
    resetForm() {
      this.submitted = false;
      this.prId = null;
      this.mrpNo = null;
      this.mrpId = null;
      this.productList = [];
      this.items = [createEmptyItem()];
    },
    productLabel(item) {
      if (!item) return "";
      return `${item.productCode} - ${item.productNameMain}`;
    },
    getProductOptionsForRow(index) {
      const currentId = this.items[index]?.product?.productId;
      return this.productList.filter(
        p =>
          !this.selectedProductIds.includes(p.productId) ||
          p.productId === currentId
      );
    },
    getUnitOptions(item) {
      if (!item.product) return [];
      const units = [];
      if (item.product.productUnit) {
        units.push({
          id: item.product.productUnit.id,
          name: item.product.productUnit.description,
        });
      }
      const conversions = item.product.productConversionUnitItems || [];
      for (const c of conversions) {
        const uom = c.uom || c.productSubUnit || null;
        if (uom && uom.id && !units.find(u => u.id === uom.id)) {
          units.push({ id: uom.id, name: uom.description });
        }
      }
      return units;
    },
    unitLabel(item) {
      return item?.name || item?.description || "";
    },
    onProductChange(index, product) {
      const item = { ...this.items[index], product };
      if (product?.productUnit) {
        item.unit = {
          id: product.productUnit.id,
          name: product.productUnit.description,
        };
      } else {
        item.unit = null;
      }
      item.qtyTouched = false;
      this.$set(this.items, index, item);
    },
    onUnitChange(index, unit) {
      this.$set(this.items, index, { ...this.items[index], unit });
    },
    onQtyChange(index, val) {
      const qty = val == null ? null : parseInt(val, 10);
      this.$set(this.items, index, { ...this.items[index], qty });
    },
    addItem() {
      this.items.push(createEmptyItem());
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    async create() {
      this.items.forEach((item, i) =>
        this.$set(this.items, i, {
          ...item,
          productTouched: true,
          qtyTouched: true,
        })
      );
      const isValid = this.items.every(i => i.product && i.qty && i.unit);
      if (!isValid) return;
      this.isLoading = true;
      try {
        await this.createPurchaseReuqest({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          mrpId: this.mrpId,
          lines: this.items.map(i => ({
            id: i.product.productId,
            quantity: i.qty,
            uomId: i.unit.id,
          })),
        });
        this.$parent.showDialogToast(
          "success",
          "แปลงรายการใบวางแผนความต้องการวัสดุเป็นใบขอซื้อสำเร็จ"
        );
        this.fetchMrpList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
        this.fetchPurchaseRequests({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
        this.$emit("success");
        this.close();
      } catch (err) {
        console.error("createPurchaseReuqest failed", err);
        this.$parent.showDialogToast(
          "danger",
          "แปลงรายการใบวางแผนความต้องการวัสดุเป็นใบขอซื้อไม่สำเร็จ กรุณาลองใหม่"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async update() {
      this.items.forEach((item, i) =>
        this.$set(this.items, i, {
          ...item,
          productTouched: true,
          qtyTouched: true,
        })
      );
      const isValid = this.items.every(i => i.product && i.qty && i.unit);
      if (!isValid) return;
      this.isLoading = true;
      try {
        await this.updatePurchaseRequest({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          prId: this.prId,
          lines: this.items.map(i => ({
            id: i.product.productId,
            quantity: i.qty,
            uomId: i.unit.id,
          })),
        });
        this.$parent.showDialogToast("success", "แก้ไขใบขอซื้อสำเร็จ");
        this.fetchPurchaseRequests({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
        this.$emit("success");
        this.close();
      } catch (err) {
        console.error("updatePurchaseRequest failed", err);
        this.$parent.showDialogToast(
          "danger",
          "แก้ไขรายการใบขอซื้อไม่สำเร็จ กรุณาลองใหม่"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.footer-warning-text {
  font-size: 14px;
  font-weight: 400;
  color: #6d747d;
  margin-left: auto;
  margin-right: 20px;
}

.pr-info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 10px;
}

.pr-info-label {
  font-weight: 600;
  white-space: nowrap;
  color: #212529;
}

.pr-info-value {
  color: #212529;
}

.add-item-btn {
  padding: 0;
  font-size: 0.9rem;
  text-decoration: none;
}

.add-item-btn:hover {
  text-decoration: underline;
}

::v-deep .modal-body {
  padding: 16px 16px 0 !important;
}

::v-deep .component-modal-product .modal-dialog {
  max-width: 1300px;
}

::v-deep .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 0;
}

::v-deep .b-table {
  min-width: 750px;
}

::v-deep td {
  padding: 8px;
  vertical-align: middle !important;
}

::v-deep th {
  vertical-align: middle !important;
}

::v-deep .bottom-add-row {
  text-align: left !important;
  margin-top: 5px;
}

::v-deep #createOrUpdatePurchaseRequestTable .bottom-row-cell {
  text-align: left !important;
}

::v-deep #createOrUpdatePurchaseRequestTable tbody tr:last-child td {
  border-bottom: none !important;
}

::v-deep
  #createOrUpdatePurchaseRequestTable.table-hover
  tbody
  tr:last-child:hover {
  background-color: transparent !important;
}

::v-deep .delete-btn {
  background-color: transparent;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  color: #a3a4a6;
  font-size: 20px;
  width: 48px;
  height: 38px;
}

.delete-btn:hover:not(:disabled) {
  background-color: #d33;
  color: #fff;
}

.delete-btn:disabled {
  border-color: #ebebeb !important;
  color: #ebebeb !important;
  cursor: not-allowed;
}
</style>
